import React from 'react';
import PortalLoader from './components/PortalLoader';
import LoadingBar from './components/portals/LoadingBar';
import { useCart } from './hooks/useCart';
import CONSTANTS from './_constants';
import { Toast } from './components/portals/Toast';
import { useDispatch } from 'react-redux';
import { dispatchToast } from './store/actions/toast';
import CartCountBadge from './components/portals/CartCountBadge';
import ProductRecommendations from './components/portals/ProductRecommendations';
import CartRecommendations from './components/portals/CartRecommendations';

export const App: React.FC = () => {

  const dispatch = useDispatch();
  useCart();
  window['blubolt'].dispatchToast = (type: string, data: any) => dispatch(dispatchToast(type, data));

  return (
    <div>
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.LOADING}
        Component={LoadingBar}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.TOAST}
        Component={Toast}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.CART_COUNT_BADGE}
        Component={CartCountBadge}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.PRODUCT_RECOMMENDATIONS}
        Component={ProductRecommendations}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.CART_RECOMMENDATIONS}
        Component={CartRecommendations}
      />
    </div>
  )
}

export default App;
